import {Stack} from '@mui/material'
import React, {useState} from 'react'
import EmptyTax from './EmptyTax'
import FormTax from './FormTax'
import EmptyFormTax from './EmptyFormTax'
import TaxApi from '../../../Api/SettingTax'
import Loading from '../../../componet/loading'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import Error403 from '../../errors/components/Error403'
import NoNetWork from '../../customTable/NoNetWork'

export default function Tax() {
  const [data, setData] = React.useState<any>(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)
  React.useEffect(() => {
    TaxApi.get((res: any) => {
      // Empty tax is a valid state (API returns status:false + null data).
      if (res?.ErrorStatus || res?.status === false || !res?.data) {
        setData(null)
        return
      }
      setData({...res.data})
    }, setIsLoading)
  }, [])
  const store = useSelector((state: RootState) => state.vender)
  return (
    <NoNetWork>
      {' '}
      <>
        {store.permissions && store.permissions && store.permissions.includes('vendor_tax') ? (
          <Stack width={'100%'} height={'60vh'} position={'relative'}>
            {isLoading ? (
              <Loading />
            ) : (
              <>
                {!data ? (
                  <EmptyTax setData={setData} data={data} />
                ) : (
                  <Stack
                    p='24px'
                    borderRadius={'8px'}
                    bgcolor={'var(--bs-app-header-base-bg-color)'}
                    width={'100%'}
                  >
                    <EmptyFormTax
                      setIsLoading={setIsLoadingBtn}
                      isLoading={isLoadingBtn}
                      setData={setData}
                      data={data}
                      isEdit
                    />
                  </Stack>
                )}
              </>
            )}
          </Stack>
        ) : (
          <Error403 />
        )}
      </>
    </NoNetWork>
  )
}
